import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { Select, SelectOption, ChangeContext } from 'tea-component';

interface IGeneralSelectProps {
  className?: string;
  style?: React.CSSProperties;
  label: string;
  options: SelectOption[];
  value: string;
  onChange: (value: string, context: ChangeContext) => void;
}

const GeneralSelect: React.FC<IGeneralSelectProps> = (props) => {
  const { className, style, label, options = [], value, onChange, ...restProps } = props;

  const { formatMessage } = useIntl();

  const valueOption = options?.find((option) => option?.value === value);

  return (
    <Select
      {...restProps}
      className={classnames('select-item', className)}
      style={{ width: 270, ...style }}
      matchButtonWidth
      appearance="button"
      listHeight={235}
      options={options}
      value={value}
      onChange={onChange}
      button={() => (
        <div className="dbi-select-button">
          <div className="select-button-text">{formatMessage({ id: label })}</div>
          <span className="select-button-desc">{valueOption?.text}</span>
        </div>
      )}
    />
  );
};

export default GeneralSelect;
